import {
  DEBUG_FORCE_DOWNSELL_TOAST_STORAGE_KEY,
  DOWNSELL_TOAST_SHOWN_STORAGE_KEY,
} from 'src/constants/storageKeys.const';
import { isNotProduction } from 'src/utils/env/isNotProduction';
import {
  getLocalStorageEntry,
  getSessionStorageEntry,
  removeSessionStorageEntry,
  setSessionStorageEntry,
} from 'src/utils/webStorageUtils';

/** Dev-only override, set via DevTools, to force the treatment arm on the next dismiss. */
export const isDownsellToastForced = (): boolean =>
  isNotProduction() && getLocalStorageEntry(DEBUG_FORCE_DOWNSELL_TOAST_STORAGE_KEY) === 'true';

export const hasShownDownsellToastThisSession = (): boolean =>
  getSessionStorageEntry(DOWNSELL_TOAST_SHOWN_STORAGE_KEY) === 'true';

export const markDownsellToastShown = (): void => {
  setSessionStorageEntry(DOWNSELL_TOAST_SHOWN_STORAGE_KEY, 'true');
};

export const resetDownsellToastSessionCap = (): void => {
  removeSessionStorageEntry(DOWNSELL_TOAST_SHOWN_STORAGE_KEY);
};

/** Once per session, for either the real treatment arm or a DevTools-forced preview. */
export const shouldShowDownsellToast = (variant: 'control' | 'treatment' | null): boolean =>
  !hasShownDownsellToastThisSession() && (isDownsellToastForced() || variant === 'treatment');
